export default "__VITE_ASSET__mxyI3JQR__"